import styled from "styled-components";
import { breakpoints } from "styles";

export const StyledShareButton = styled.button<{ isTextCopied: boolean }>`
  position: relative;
  --webkit-appearance: none;
  border: none;
  cursor: pointer;
  padding: 6px 8px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 75px;
  color: ${({ isTextCopied, theme }) =>
    isTextCopied ? theme.colors.green[100] : theme.colors.brand[500]};
  background: ${({ isTextCopied, theme }) =>
    isTextCopied ? theme.colors.green[700] : theme.colors.brand[100]};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.primary};

  @media ${breakpoints.tablet} {
    width: 90px;
    font-size: ${({ theme }) => theme.fontSizes.sm};
  }
`;
